<script setup lang="ts">
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { type Color, getColorValue } from '@global-types/colors';
import { useIconCache } from '@composables/useIconCache';
import Logger from '@tools/logger/logger';

interface IconProps {
  name: string;
  title?: string;
  width?: string | number;
  height?: string | number;
  fill?: Color | 'current' | 'none';
  stroke?: Color | 'current';
}

const props = defineProps<IconProps>();

const { svgUrl } = useIconCache(props.name);

const colorValue = computed<string | undefined>(() => {
  if (props.fill === undefined) {
    return undefined;
  }

  if (props.fill === 'current') {
    return 'currentColor';
  }

  if (props.fill === 'none') {
    return 'none';
  }

  return getColorValue(props.fill);
});

const strokeColorValue = computed<string | undefined>(() => {
  if (props.stroke === undefined) {
    return undefined;
  }

  if (props.stroke === 'current') {
    return 'currentColor';
  }

  return getColorValue(props.stroke);
});
</script>

<template>
  <InlineSvg
    v-if="svgUrl"
    :src="svgUrl"
    :title="title"
    :width="width"
    :height="height"
    :fill="colorValue"
    :style="stroke ? { color: strokeColorValue } : undefined"
  />
</template>
